import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, setCsrf } from "@/lib/api";

const Ctx = createContext(null);

export function StaffAuthProvider({ children }) {
  const [state, setState] = useState({ user: null, permissions: [], roles: [], loading: true });

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/auth/staff/me");
      setCsrf("staff", r.data.csrf_token);
      setState({ user: r.data.user, permissions: r.data.permissions, roles: r.data.roles, loading: false });
    } catch {
      setCsrf("staff", null);
      setState({ user: null, permissions: [], roles: [], loading: false });
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const r = await api.post("/auth/staff/login", { email, password });
    setCsrf("staff", r.data.csrf_token);
    setState({ user: r.data.user, permissions: r.data.permissions, roles: r.data.roles, loading: false });
    return r.data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/staff/logout");
    } finally {
      setCsrf("staff", null);
      setState({ user: null, permissions: [], roles: [], loading: false });
    }
  };

  const can = (perm) => state.permissions.includes(perm);
  return <Ctx.Provider value={{ ...state, login, logout, refresh, can }}>{children}</Ctx.Provider>;
}

export const useStaff = () => useContext(Ctx);
